import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import { useSelector } from "react-redux";
import { modeSelector } from "../../store/selectors/app.selector";
import CommonOtp from "../../components/otp-pre-login";

export default function ForgotPasswordOTP(data = {}) {
  const [otp, setOtp] = useState("");
  const mode = useSelector(modeSelector);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);

  const onConfirm = useCallback(async (values) => {
    try {
      const reqParams = {
        ...values,
        mode: mode,
      };
      const response = await AuthService.forgotPasswordConfirm(reqParams);
      if (response.status === 200) {
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  const resendOtp = useCallback(async () => {
    try {
      setOtp("");
      const reqParams = {
        userName: data?.data?.userName,
        dob: data?.data?.dob,
      };
      const response = await AuthService.forgortPasswordVerify(reqParams);
      if (response.status === 200) {
      }
    } catch (error) {
      setOtp("");
    }
  }, [data]);

  return (
    <>
      <CommonOtp
        otp={otp}
        setOtp={setOtp}
        type="TRANSACTION"
        onConfirm={() => onConfirm({ ...data?.data, otp: otp })}
        handleResendOtp={() => resendOtp()}
        cancelTransaction={() => {
          navigate("/login");
        }}
        verifyDetails={data?.data}
        successVisible={successVisible}
        message={message}
        routingURL={"/login"}
      />
    </>
  );
}
